// @flow

import { observer } from "mobx-react";
import React from "react";

import TimelineItem, { REACTIONS } from "app/models/TimelineItem";
import TimelineCardReaction from "app/components/TimelineCardReaction/TimelineCardReaction";
import TimelineCardShare from "app/components/TimelineCardShare/TimelineCardShare";
import AppearanceStore from "app/stores/AppearanceStore";

import "./TimelineCardSocial.scss";

type Props = {
    item: TimelineItem,
    userId: ?number,
    onReact: Function,
    onForward?: Function
};

// Reactions disabled as requested on task https://www.scalablepath.com/t/20704
const DISABLE_CARD_REACTIONS = true;

@observer
export default class TimelineCardSocial extends React.Component<Props> {
    render() {
        const item: TimelineItem = this.props.item;

        return (
            <div className="TimelineCardSocial">
                {this.renderReaction(REACTIONS.LIKE, item.total_likes)}
                {this.renderReaction(REACTIONS.DISLIKE, item.total_dislikes)}

                {this.renderShareButton()}
            </div>
        );
    }

    renderShareButton() {
        if (AppearanceStore.isMobile || AppearanceStore.embed) {
            return null;
        }

        return <TimelineCardShare item={this.props.item} />;
    }

    renderReaction(type: number, total: ?number) {
        if (DISABLE_CARD_REACTIONS) return null;

        total = total || 0;
        return (
            <TimelineCardReaction
                userId={this.props.userId}
                userReaction={this.props.item.user_reaction}
                type={type}
                total={total}
                onReact={this.props.onReact}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineCardSocial/TimelineCardSocial.js